import { ApplicationInsights, SeverityLevel } from '../ReactComponents/ApplicationInsights';
import { Recommendations } from './ViewModels/Recommendations';
import { RecommendationsCache } from './ViewModels/RecommendationsCache';
import { RecommendationsEventNameResolver } from './ViewModels/RecommendationsEventNameResolver';

export class RecommendationsRepository {
    /* eslint-disable */

    public static populateRepository(widgetsData: any) {
        let widgetNames: string[];
        let recommendations: Recommendations;
        try {
            recommendations = JSON.parse(widgetsData) as Recommendations;
            widgetNames = recommendations.smartRecs.map((r) => r.widget);
        } catch (err: any) {
            ApplicationInsights.TrackTrace(SeverityLevel.Error, `Failed to parse JSON in populateRepository. Data: ${widgetsData} Error: ${err}`);
            return;
        }

        widgetNames.forEach((widgetName) => {
            if (recommendations?.smartRecs) {
                const recs = recommendations.smartRecs.filter((r) => r.widget == widgetName)[0].recs;
                const event = new CustomEvent(RecommendationsEventNameResolver.GetEventName(widgetName));
                const serializedRecs = JSON.stringify(recs);

                if (RecommendationsCache.getRecommendations(widgetName) != serializedRecs) {
                    RecommendationsCache.saveRecommendations(widgetName, serializedRecs);
                    window.dispatchEvent(event);
                }
            }
        });
    }
}
